// The Knowledge bank singleton tab's centre (#60): the source gone into
// (`selectedId`, `/knowledge/{id}`) in its reader. The list of sources is
// Search scoped to Sources (pen "One search"), so a tab restored without a
// source points there.

import { useLingui } from "@lingui/react/macro";
import type { ReactNode } from "react";
import { Button } from "../../../components/Button/Button.js";
import { EmptyState } from "../../../components/EmptyState/EmptyState.js";
import { knowledgeRowsOf } from "../../../components/KnowledgeBank/knowledgeBankModel.js";
import type { FocusTarget } from "../../../components/Navigation/types.js";
import { useAppShell } from "../context.js";
import { centeredStyle } from "../styles.js";
import { KnowledgeItem } from "./KnowledgeItem.js";

export const KnowledgeCentre = ({
    selectedId,
    target,
}: {
    readonly selectedId?: string | undefined;
    readonly target?: FocusTarget | undefined;
}): ReactNode => {
    const { t } = useLingui();
    const { library, searchResults, dispatch } = useAppShell();

    if (selectedId === undefined)
        return (
            <div style={centeredStyle}>
                <EmptyState title={t`Uploaded sources are in Search`}>
                    <Button
                        variant="primary"
                        onClick={() =>
                            dispatch({ type: "open-search", kind: "source" })
                        }
                    >
                        {t`Open Uploaded sources`}
                    </Button>
                </EmptyState>
            </div>
        );

    const rows = knowledgeRowsOf(searchResults, library);
    return (
        <KnowledgeItem
            id={selectedId}
            row={rows.find((r) => r.id === selectedId)}
            target={target}
        />
    );
};
